<template>
  <div>
    <div class="invalid" v-if="fileError">
      <h3>{{fileError}}</h3>
    </div>
    <div class="valid" v-if="!Object.keys(importerErrors).length && !Object.keys(importerWarnings).length"></div>
    <div class="invalid" v-if="Object.keys(importerErrors).length">
      <h3>Errors found in file. Data was not imported. Resolve the following issues and retry:</h3>

      <table class="table table-hover table-tags table-data">
        <tr>
          <th class="w-1/10">Row</th>
          <th>Message</th>
        </tr>
        <template v-for="talentErrors in importerErrors">
            <tr :key="lineIndex" v-for="(lineError,lineIndex) in talentErrors">
              <td class="w-1/10">{{isNaN(lineIndex) ? '' : parseInt(lineIndex) + 1}} </td>
              <td>
                <span v-if="typeof lineError === 'string'">{{lineError}}</span>
                <div v-else :key="columnIndex" v-for="(columnErrors, columnIndex) in lineError">
                  <div :key="index" v-for="(error, index) in columnErrors">
                    {{error}}
                  </div>
                </div>
              </td>
            </tr>
        </template>
      </table>
    </div>
    <div class="invalid" v-if="Object.keys(importerWarnings).length">
      <h3>Warnings found in file.</h3>

      <table class="table table-hover table-tags table-data">
        <tr>
          <th class="w-1/10">Row</th>
          <th>Message</th>
        </tr>
        <template v-for="talentWarnings in importerWarnings">
          <tr :key="lineIndex" v-for="(lineError,lineIndex) in talentWarnings">
            <td class="w-1/10">{{parseInt(lineIndex)+1}} </td>
            <td>
              <div :key="columnIndex" v-for="(columnErrors, columnIndex) in lineError">
                {{columnErrors}}
              </div>
            </td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import TalentDashboard from '../dashboards/TalentDashboard'
export default {
  name: 'validate-input',
  components: {TalentDashboard},
  props: [
    'importerErrors',
    'importerWarnings',
    'fileError'
  ]
}
</script>

<style scoped>
  .invalid{
    margin-top:50px;
  }
</style>
